module.exports = __webpack_public_path__ + "img/ninguno-blanco-viciado.f95ffb03.png";